module.exports = __webpack_public_path__ + "img/popout-icon.6080cf34.svg";